import { Component, Prop, Vue } from 'vue-property-decorator';
import { WidgetContentActualResultsPieChart } from '@/components/Dashboard/Widgets/types/Widget';

@Component
export default class ActualResultsRate extends Vue {

    @Prop()
    public widgetPieChart!: WidgetContentActualResultsPieChart;


    private minusRate = false;
    private incomeColor = true;
    private budgetColor = false;
    private profitColor = false;

    get isShadow() {
        return (this.widgetPieChart.rate > 100 || this.widgetPieChart.rate < -100) 
    }
    
    get shadowAngle() {
        return 'transform:rotate(' + 360 * 0.01 * (this.widgetPieChart.rate % 100) + 'deg);';       
    }

    get pieChartTittle() {
        if(this.widgetPieChart.pieChartStatus == 'income') {
            return '収入達成状況'
        } else if(this.widgetPieChart.pieChartStatus == 'outgo') {
            return '支出状況'
        } else if (this.widgetPieChart.pieChartStatus == 'profit') {
            return '利益達成状況'
        }
    }

    get pieChartStyle() {
        let color
        switch (this.widgetPieChart.pieChartStatus) {
            case 'income':
                this.incomeColor = true;
                this.budgetColor = false;
                this.profitColor = false;
                color = "#4B98CF";
                this.minusRate = false;
                break
            case 'outgo':
                this.incomeColor = false;
                this.budgetColor = true;
                this.profitColor = false;
                color = (this.widgetPieChart.rate > 100) ? "#F50000" : "#E47B62";
                this.minusRate = (this.widgetPieChart.rate > 100);
                break
            case 'profit':
                this.incomeColor = false;
                this.budgetColor = false;
                this.profitColor = true;
                color = (this.widgetPieChart.rate < 0) ? "#F50000" : "#2CB18E";
                this.minusRate = (this.widgetPieChart.rate < 0);
                break
        }
        if(this.widgetPieChart.rate > 100 || this.widgetPieChart.rate < -100 ) {
            return { 'background-image' : 'conic-gradient(transparent 0% 0%, ' + color + ' 0% 100%)' }
        } else if(this.widgetPieChart.rate > 0) {
            return { 'background-image' : 'conic-gradient(' + color + ' 0% ' + this.widgetPieChart.rate + '%, transparent ' + this.widgetPieChart.rate + '% 100%)' }
        } else {
            return { 'background-image' : 'conic-gradient(transparent 0% ' + (100 + this.widgetPieChart.rate) + '%, ' + color + ' ' + this.widgetPieChart.rate + '% 100%)' }
        }
    }
}


